import React from "react";
import { toast, ToastOptions } from "react-toastify";
import BellIcon from "../../../assets/icon-bell.svg";
import CrossIcon from "../../../assets/icon-close.svg";

const CloseButton = ({ closeToast }) => (
  <button onClick={closeToast} className="toast-close-button">
    <CrossIcon />
  </button>
);

export const showApiErrorToast = (message: string = "Something went wrong. some time.") => {
  const toastOptions: ToastOptions = {
    icon: false,
    className: "custom-error-toast",
    closeButton: <CloseButton closeToast={() => {}} />,
  };

  toast(
    <div
      className="custom-error-toast-content"
    >
      <BellIcon />
      <span className="toast-error-message">{message}</span>
    </div>,
    toastOptions
  );
};
